<template>
  <div>
    <form>
      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md2
        >
          <v-select
            v-model="form.vek"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.vek"
            label="Vek"
            name="Vek"
            :error-messages="errors.collect('Vek')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('vek')"
          />
        </v-flex>

        <v-flex
          xs12
          md3
        >
          <v-select
            v-model="form.pohlavie"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.pohlavie"
            label="Pohlavie"
            name="Pohlavie"
            :error-messages="errors.collect('Pohlavie')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('pohlavie')"
          />
        </v-flex>

        <v-flex
          xs12
          md4
        >
          <v-select
            v-model="form.vo_vtos"
            v-validate="'required'"
            :disabled="form.closed"
            label="Vo výkone trestu odňatia slobody"
            :items="selects.vo_vtos"
            name="Vo výkone trestu odňatia slobody"
            :error-messages="errors.collect('Vo výkone trestu odňatia slobody')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('vo_vtos')"
          />
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.najvyssie_dosiahnute_vzdelanie"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.najvyssie_dosiahnute_vzdelanie"
        label="Najvyššie dosiahnuté vzdelanie"
        name="Najvyššie dosiahnuté vzdelanie"
        :error-messages="errors.collect('Najvyššie dosiahnuté vzdelanie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('najvyssie_dosiahnute_vzdelanie')"
      />

      <v-select
        v-model="form.aktualne_odsudeny_za"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.aktualne_odsudeny_za"
        label="Aktuálne odsúdený za"
        name="Aktuálne odsúdený za"
        :error-messages="errors.collect('Aktuálne odsúdený za')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('aktualne_odsudeny_za')"
      />

      <v-checkbox
        v-model="form.porusenie_podmienky"
        :disabled="form.closed"
        label="Porušenie podmienky (5 rokov pred nástupom na VTOS)"
        name="Porušenie podmienky (5 rokov pred nástupom na VTOS)"
        :error-messages="errors.collect('Porušenie podmienky (5 rokov pred nástupom na VTOS)')"
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('porusenie_podmienky')"
      />

      <v-checkbox
        v-model="form.clenstvo_v_zlocineckej"
        :disabled="form.closed"
        label="Členstvo v zločineckej skupine"
        name="Členstvo v zločineckej skupine"
        :error-messages="errors.collect('Členstvo v zločineckej skupine')"
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('clenstvo_v_zlocineckej')"
      />

      <v-layout
        wrap
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.aktualna_dlzka_nepretrziteho_pobytu"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.aktualna_dlzka_nepretrziteho_pobytu"
            label="Aktuálna dĺžka nepretržitého pobytu vo výkone trestu odňatia slobody"
            name="Aktuálna dĺžka nepretržitého pobytu vo výkone trestu odňatia slobody"
            :error-messages="errors.collect('Aktuálna dĺžka nepretržitého pobytu vo výkone trestu odňatia slobody')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('aktualna_dlzka_nepretrziteho_pobytu')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.dlzka_zamestnania_rok_pred"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.dlzka_zamestnania_rok_pred"
            label="Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody"
            name="Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody"
            :error-messages="errors.collect('Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('dlzka_zamestnania_rok_pred')"
          />
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.spolupraca_s_inymi_org"
        v-validate="'required'"
        :disabled="form.closed"
        text-truncate
        :items="selects.spolupraca_s_inymi_org"
        label="Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti"
        name="Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti"
        :error-messages="errors.collect('Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('spolupraca_s_inymi_org')"
      />

      <v-select
        v-model="form.zabezpecenie_byvania_po"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.zabezpecenie_byvania_po"
        label="Zabezpečenie bývania po prepustení z výkonu trestu odňatia slobody"
        name="Zabezpečenie bývania po prepustení z výkonu trestu odňatia slobody"
        :error-messages="errors.collect('Zabezpečenie bývania po prepustení z výkonu trestu odňatia slobody')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('zabezpecenie_byvania_po')"
      />

      <v-select
        v-model="form.aktualna_financna_situacia"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.aktualna_financna_situacia"
        label="Aktuálna finančná situácia"
        name="Aktuálna finančná situácia"
        :error-messages="errors.collect('Aktuálna finančná situácia')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('aktualna_financna_situacia')"
      />

      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :readonly="form.closed"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="0"
            max="3"
            ticks="always"
            :color="color"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="indigo"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-title>
            <span class="headline">Charakteristika</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.charakteristika"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Zdroj</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.zdroj"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Príklad</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.priklad"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Poznámka</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.poznamka"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new"
  },

  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: []
    },

    form: {
      id: null,
      vek: "",
      pohlavie: "",
      vo_vtos: "",
      najvyssie_dosiahnute_vzdelanie: "",
      aktualne_odsudeny_za: "",
      porusenie_podmienky: "",
      clenstvo_v_zlocineckej: "",
      aktualna_dlzka_nepretrziteho_pobytu: "",
      dlzka_zamestnania_rok_pred: "",
      spolupraca_s_inymi_org: "",
      zabezpecenie_byvania_po: "",
      aktualna_financna_situacia: "",
      expertne_posudenie: 1,

      closed: false
    },

    craItem: {
      closed: true
    },

    selects: {
      vek: [
        "14 – 18 rokov",
        "19 – 30 rokov",
        "31 – 45 rokov",
        "46 – 60 rokov",
        "61 a viac rokov"
      ],
      pohlavie: ["muž", "žena"],
      vo_vtos: ["1 krát", "2 krát", "3 a viackrát"],
      najvyssie_dosiahnute_vzdelanie: [
        "vysokoškolské",
        "stredoškolské s maturitou",
        "stredné odborné vzdelanie bez maturity, s výučným resp. záučným listom",
        "základné (základná škola)",
        "špeciálna škola",
        "neukončené základné vzdelanie"
      ],
      aktualne_odsudeny_za: [
        "prečin spáchaný bez použitia násilia",
        "prečin spáchaný za použitia násilia alebo jeho hrozby",
        "zločin spáchaný bez použitia násilia",
        "zločin spáchaný za použitia násilia alebo jeho hrozby",
        "obzvlášť závažný zločin spáchaný bez použitia násilia",
        "obzvlášť závažný zločin spáchaný za použitia násilia alebo jeho hrozby"
      ],
      aktualna_dlzka_nepretrziteho_pobytu: [
        "0 – 1 rok",
        "viac ako 1 rok a menej ako 2 roky",
        "2 roky – 5 rokov",
        "viac ako 5 rokov"
      ],

      dlzka_zamestnania_rok_pred: [
        "Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS",
        "Zamestnaný menej ako 12 mesiacov - 3 mesiace",
        "Zamestnaný menej ako 3 mesiace",
        "Nezamestnaný nepretržite 12 mesiacov pred nástupom do VTOS"
      ],
      spolupraca_s_inymi_org: [
        "aktívne spolupracuje s inými profesionálnymi orgánmi, organizáciami a osobami podporujúcimi a asistujúcimi pri návrate z výkonu trestu na slobodu (napr. orgán SPODaSK, MVO, PMÚ a pod.) / z objektívnych príčin nie je spolupráca nevyhnutná",
        "spolupracuje s inými profesionálnymi orgánmi, organizáciami a osobami podporujúcimi a asistujúcimi pri návrate z výkonu trestu na slobodu (napr. orgán SPODaSK, MVO, PMÚ a pod.)",
        "nespolupracuje s inými profesionálnymi orgánmi, organizáciami a osobami podporujúcimi a asistujúcimi pri návrate z výkonu trestu na slobodu (napr. orgán SPODaSK, MVO, PMÚ a pod.)"
      ],
      aktualna_financna_situacia: [
        "bez dlhov",
        "zdokumentované aktuálne dlhy nepresahujú sumu 2.500 €",
        "zdokumentované aktuálne dlhy presahujú sumu 2.500 €"
      ],
      zabezpecenie_byvania_po: [
        "má zabezpečené dlhodobé bývanie po ukončení VTOS",
        "má zabezpečené krátkodobé bývanie po ukončení VTOS",
        "nemá zabezpečené bývanie po ukončení VTOS"
      ],
      expertne_posudenie: ["nehodnotené", "malá", "stredná", "vysoká"]
    },

    manual: {
      vek: {
        nazov: "Vek",
        charakteristika: [],
        poznamka: [],
        priklad: [],
        zdroj: ["Aplikácia VVVT."]
      },

      pohlavie: {
        nazov: "Pohlavie",
        charakteristika: [],
        poznamka: [],
        priklad: [],
        zdroj: ["Aplikácia VVVT."]
      },

      vo_vtos: {
        nazov: "Vo výkone trestu odňatia slobody",
        poznamka: [],
        charakteristika: [
          "Uvádza sa počet všetkých pobytov hodnoteného vo výkone trestu odňatia slobody (nie počet všetkých nepodmienečných trestov).Započítavame aj pobyt vo VV, keď na neho  bezprostredne nenadväzuje VTOS (ak je medzi nimi akýkoľvek časový interval)."
        ],
        zdroj: [
          "Aplikácia VVVT – mŕtvy stav, odpis registra trestov (pri odsúdených, starších ako 35 rokov)."
        ],
        priklad: [
          "1. Odsúdený Baláž Aladár má v osobnej karte 1 recidívu vyznačenú 16/10 (tzn. že bol 16 x súdne trestaný a z toho bolo 10 nepodmienečných trestov). Avšak menovaný sa v minulosti nachádzal vo výkone trestu odňatia slobody len 3 x (rozdiel je spôsobený spoločným výkonom viacerých nepodmienečných trestov) – v  CRA-CR a CRA-RU sa mu označí riadok 3 a viackrát pretože menovaný je vo výkone trestu odňatia slobody 4 x.",
          "2. Odsúdený Kováč Jozef má v osobnej karte vyznačenú recidívu 0/0. Má však 45 rokov, z čoho vyplýva, že mohol byť vo VV alebo vo VTOS pred rokom 2004 (spustenie aplikácie VVVT). V takomto prípade prípadnú recidívu uvedieme na základe lustrácie odpisu registra trestov."
        ]
      },

      najvyssie_dosiahnute_vzdelanie: {
        nazov: "Najvyššie dosiahnuté vzdelanie",
        charakteristika: [],
        zdroj: [
          "Prioritne vychádzame z Aplikácie VVVT - osobná karta č. 2, resp. z dotazníka pri nástupe do / v priebehu výkonu trestu odňatia slobody. V prípade, že zistíme rozpor medzi údajmi zaznamenanými v osobnej karte č. 2 a tvrdením odsúdeného počas pohovorov (napr. pohovor počas pobytu v nástupnom oddiele / pohovor pred spracovaním CRA-CR a CRA-RU), postupujeme nasledovne:",
          "Ak pri pohovore zistíme, že odsúdený dosiahol nižší stupeň vzdelania ako sa uvádza v osobnej karte č. 2, označíme ním uvedené  nižšie dosiahnuté vzdelanie. V tomto prípade odsúdeného nesankcionujeme v položke 5 a) - Nepravdivé/zavádzajúce informácie.",
          "Ak odsúdený pri pohovore uvádza (a na svojom tvrdení trvá), že dosiahol vyššie vzdelanie, ako je zaznamenané v osobnej karte č. 2 (údaj čerpaný z dotazníka, ktorý odsúdený vyplňuje pri nástupe do výkonu trestu), je vyzvaný k predloženiu potvrdenia o dosiahnutom vzdelaní. Ak potvrdenie nepredloží najneskôr do spracovania CRA-CR a CRA-RU, uvedieme mu nižšie vzdelanie a sankcionujeme ho v bode 5 a) - Nepravdivé/zavádzajúce informácie."
        ],
        poznamka: [
          "Ak sociálny pracovník zistí rozpor medzi tvrdeniami odsúdeného a preukázateľným stavom, tak tento údaj zaznačí do VVVT (hodnotenie sociálnej situácie pri nástupe do VTOS) a informuje o tom administratívne oddelenie."
        ],
        priklad: [
          "Odsúdený tvrdí, že má ukončené stredoškolské vzdelanie s maturitou. Pri nástupe do výkonu trestu však uviedol, že nedokončil základnú školu a tento údaj má zaznačený v osobnej karte č. 2 v aplikácii VVVT. Keďže svoje tvrdenie o ukončení strednej školy nedoložil, v CRA-CR a CRA-RU sa mu označí riadok neukončil základné vzdelanie. Jeho tvrdenie môžeme v takomto prípade hodnotiť ako nepravdivú/zavádzajúcu informáciu a sankcionujeme ho v položke 5 a)."
        ]
      },

      aktualne_odsudeny_za: {
        nazov: "Aktuálne odsúdený za",
        charakteristika: [
          "Pri hodnotení položky rozlišujeme dve definičné kritériá:",
          "a) závažnosť trestného činu (prečin - § 10 Trestného zákona, zločin - § 11 ods. 1 a 2 Trestného zákona a obzvlášť závažný zločin § 11 ods. 3 Trestného zákona) a",
          "b) násilie (pojem násilie je definovaný v § 122 ods. 7 Trestného zákona)."
        ],
        zdroj: [
          "Ad a) Primárne je zistenie závažnosti trestného činu možné z rozsudku, kde je to slovne uvedené vo výrokovej časti ale rovnako aj v odôvodnení pred názvom trestného činu a číslom paragrafu Trestného zákona.",
          "*V prípade absencie rozsudku je možné zistiť závažnosť trestného činu aj podľa čísla paragrafu trestného činu uvedeného v osobnej karte 1 a následnej aplikácie definícií prečin - § 10 Trestného zákona, zločin - § 11 ods. 1 a 2 Trestného zákona a obzvlášť závažný zločin.",
          "Ad b) Násilie je znak, ktorý je pri vybraných trestných činoch spravidla súčasťou spáchaného trestného činu **(napr. vražda podľa § 145 Trestného zákona), pri ďalších trestných činoch je jednou z alternatív ich spáchania (napr. krádež podľa § 212 ods. 2 písm. b) Trestného zákona) a pri ostatnej skupine trestných činov je použitie násilia spravidla vylúčené (napr. neoznámenie trestného činu§ 340 Trestného zákona).",
          "Použitie násilia je primárne možné zistiť z rozsudku, kde je v odôvodnení pri opise skutku vyjadrené ako presne bol daný trestný čin spáchaný. Rovnako je spravidla možné určiť použitie násilia na základe čísla paragrafu trestného činu uvedeného v osobnej karte 1 (k tomu pozri príklad ** nižšie)."
        ],
        poznamka: [
          "Pri výkone trestu odňatia slobody za viacero trestných činov hodnotíme najzávažnejší trestný čin."
        ],
        priklad: [
          "* Ak je v osobnej karte 1 uvedené § 277 ods. 4 TZ pôjde o zločin, pretože príslušný paragraf v odseku 4 vymedzuje trest odňatia slobody so sadzbou na sedem rokov až dvanásť rokov, čo napĺňa definičné kritéria zločinu v § 11 ods. 1 a 2 Trestného zákona, keďže ide o úmyselný trestný čin (k tomu pozri § 17 Trestného zákona)s hornou hranicou trestnej sadzby prevyšujúcou päť rokov.",
          "** Pri trestnom čine vraždy je násilie spravidla súčasťou skutku a to aj napriek tomu, že sa tento znak nie je explicitne vyjadrený priamo v skutkovej podstate vraždy v § 145 Trestného zákona (len vo výnimočných prípadoch je možné spáchať vraždu bez použitia násilia). Pri iných trestných činoch napr. lúpež podľa § 188 Trestného zákona je znak násilia uvedený explicitne priamo v skutkovej podstate."
        ]
      },

      porusenie_podmienky: {
        nazov: "Porušenie podmienky (5 rokov pred nástupom na VTOS)",
        poznamka: [],
        charakteristika: [
          "Uvádza sa skutočnosť, či odsúdený 5 rokov pred nástupom do výkonu trestu odňatia slobody porušil / neporušil podmienky v prípade podmienečného odsúdenia alebo podmienečného prepustenia. Pre termín porušenia podmienky je rozhodujúci termín nariadenia výkonu trestu."
        ],
        zdroj: [
          "Odpis registra trestov, osobný spis, konzultácia s úsekom administratívy."
        ],
        priklad: [
          "Podľa odpisu z registra trestov bol ods. Stopka odsúdený 8. novembra 2007 na trest odňatia slobody s podmienečným odkladom so skúšobnou dobou v trvaní do 8. novembra 2011. Menovaný sa v skúšobne dobe neosvedčil, nakoľko mal 2. júla 2009 nariadený výkon trestu. Po prepustení nastúpil výkon nového (aktuálneho) nepodmienečného trestu odňatia slobody dňa 1. februára 2013."
        ]
      },

      clenstvo_v_zlocineckej: {
        nazov: "Členstvo v zločineckej skupine",
        charakteristika: [],
        priklad: [],
        zdroj: ["Aplikácia VVVT – osobná karta 1 – položka Dôležité poznatky."],
        poznamka: [
          "Pri hodnotení tohto bodu nevychádzame z autoanamnestických údajov odsúdeného, ale z údajov uvedených aplikácii VVVT, pričom pre kladné hodnotenie nie je podstatné, či členstvo v zločineckej skupine súvisí s aktuálnou trestnou činnosťou alebo ide len o operatívny poznatok preventívno-bezpečnostnej služby, resp. poznatok z predchádzajúcej trestnej činnosti. Do tohto bodu sa zarátava aj členstvo v teroristickej skupine."
        ]
      },

      aktualna_dlzka_nepretrziteho_pobytu: {
        nazov: "Aktuálna dĺžka nepretržitého pobytu vo výkone trestu odňatia slobody",
        poznamka: [],
        priklad: [],
        charakteristika: [
          "Uvádza sa údaj od nástupu na výkon trestu aj so započítanou väzbou (ak odsúdený prišiel do výkonu trestu priamo z výkonu väzby). V prípade prerušenia trestu sa uvedie dĺžka nepretržitého pobytu v ústave odo dňa nástupu po prerušení trestu."
        ],
        zdroj: [
          "VVVT, osobná karta č. 3, pobyty v ústavoch, prvý údaj v tabuľke dole."
        ]
      },

      dlzka_zamestnania_rok_pred: {
        nazov: "Dĺžka zamestnania rok pred nástupom do výkonu trestu odňatia slobody",
        charakteristika: [
          "V tejto položke sa zohľadňuje legálna pracovná činnosť odsúdeného; ide o posúdenie pracovných návykov vyvinutím vlastnej iniciatívy počas pobytu na slobode (práca na dohodu, aktivačné práce, brigáda...). Berieme do úvahy vybudované pracovné návyky (každodenné dochádzanie na základe nejakej formy dohody s poskytovateľom práce).",
          "Nezapočítava sa práca počas predchádzajúceho VT!"
        ],
        poznamka: [
          "Ak je odsúdený študent alebo dôchodca, poberateľ materského alebo rodičovského príspevku alebo poberateľ opatrovateľského príspevku tak v CRA-CR a CRA-RU sa mu označí riadok zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS. Prihliadame / zaznamenávame aj skutočnosť, či materský, rodičovský alebo opatrovateľský príspevok odsúdený poberal 12 a viac mesiacov bezprostredne pred nástupom do VV/VTOS."
        ],
        zdroj: [
          "Autoanamnestické údaje odsúdeného - údaj čerpaný najmä z dotazníka, ktorý odsúdený vypĺňa pri nástupe do výkonu trestu / v priebehu výkonu trestu, rozsudkové údaje, portál zdravotnej poisťovne a iné"
        ],
        priklad: [
          "1. Odsúdený bol na slobode 7 mesiacov. Počas tejto doby pracoval 2-krát po jednom mesiaci brigádnicky. Uvedieme do riadku menej ako 3 mesiace.",
          "2. Odsúdený za posledný rok pred nástupom do VT bol dva mesiace na aktivačných prácach, potom tri mesiace ako skladník na dohodu v ČR a necelý mesiac pracoval na stavbe bez zmluvy. V CRA-CR a CRA-RU sa mu označí riadok menej ako 6 mesiacov – 3 mesiace.",
          "3. Odsúdený bol pred aktuálnym výkonom trestu tri mesiace na slobode. Počas tohto obdobia nikde nepracoval. Predtým vykonával trest odňatia slobody  v trvaní 9 mesiacov, počas ktorého bol pracovne zaradený. V CRA-CR a CRA-RU sa mu označí riadok 0 mesiacov – nezamestnaný nepretržite 12 mesiacov pred nástupom do VTOS."
        ]
      },

      spolupraca_s_inymi_org: {
        nazov: "Spolupráca s inými organizáciami v rámci postpenitenciárnej starostlivosti",
        charakteristika: [
          "- Aktívna spolupráca znamená osobnú, vlastnú, samostatnú iniciatívu odsúdeného.",
          "- Z objektívnych príčin spolupráca nie je potrebná znamená, že odsúdený má podporu funkčnej rodiny bez výrazných kriminogénnych rizík, má sa kam vrátiť po VTOS (zabezpečené bývanie), má prísľub pracovného zaradenia a pod.",
          "- Spolupráca znamená nesamostatnú aktivitu odsúdeného – odsúdený sa spolieha na pomoc sociálneho pracovníka, žiada sociálneho pracovníka / pedagóga nielen o zabezpečenie kontaktov, ale aj o následnú asistenciu."
        ],
        poznamka: [
          "Za aktívnu spoluprácu považujeme aj aktivitu negramotného alebo nevidiaceho odsúdeného, ktorý spolupracuje s organizáciami postpenitenciárnej starostlivosti s pomocou sociálneho pracovníka."
        ],
        zdroj: ["pohovory s odsúdeným, poznatky z korešpondencie."],
        priklad: [
          "1. Odsúdený žiada sociálneho pracovníka len o poskytnutie adresy z dôvodu nadviazania spolupráce so sociálnym kurátorom, mimovládnych organizácií. Ďalej postupuje samostatne. V CRA-CR a CRA-RU sa mu označí riadok aktívne spolupracuje.",
          "2. Odsúdený požiada sociálneho pracovníka o zabezpečenie ubytovania po skončení VT, kedy komunikáciu s úradmi zabezpečuje sociálny pracovník. V CRA-CR a CRA-RU sa mu označí riadok spolupracuje.",
          "3. Je zrejmé, že pre úspešnú resocializáciu je potrebná postpenitenciárna  pomoc, odsúdený ju však odmieta, nejaví o ňu záujem. V CRA-CR a CRA-RU sa mu označí riadok nespolupracuje."
        ]
      },

      zabezpecenie_byvania_po: {
        nazov: "Zabezpečenie bývania po prepustení z výkonu trestu odňatia slobody",
        charakteristika: [
          "- Dlhodobé bývanie znamená stále bývanie u rodiny, vlastná nehnuteľnosť, domovy sociálnych služieb a pod.",
          "- Krátkodobé bývanie znamená bývanie u rodiny  na prechodné obdobie, v azylovom dome, ubytovni, charitatívnej organizácii a pod."
        ],
        zdroj: [
          "Osobný pohovor, poznatky od blízkych, korešpondencia, návštevy, poznatky od pedagóga."
        ],
        priklad: [
          "1. Odsúdený sa vráti  bývať k manželke, k matke, do vlastného bytu...V CRA-CR a CRA-RU sa mu označí riadok dlhodobé bývanie.",
          "2. Po skončení výkonu trestu odsúdený pôjde na určitú dobu bývať k rodičom, kým si nenájde podnájom, zamestnanie s ubytovaním. V CRA-CR a CRA-RU sa mu označí riadok krátkodobé bývanie.",
          "3. Odsúdený sa po výkone trestu nemá kam vrátiť a neprejaví záujem o riešenie svojej bytovej otázky. V CRA-CR a CRA-RU sa mu označí riadok nemá zabezpečené bývanie.",
          "4. Odsúdený  sa po výkone trestu vracia bývať do segregovanej rómskej lokality (osada mimo obce/mesta). V CRA-CR a CRA-RU sa mu označí riadok má zabezpečené krátkodobé bývanie po ukončení VTOS."
        ],
        poznamka: [
          "Hodnotiteľ nevyžaduje oficiálne potvrdenie o pobyte, čestné vyhlásenie, a.p."
        ]
      },

      aktualna_financna_situacia: {
        nazov: "Aktuálna finančná situácia",
        poznamka: [],
        priklad: [],
        charakteristika: [
          "Pod aktuálnou finančnou situáciou sa myslí finančná situácia v čase spracovávania CRA-CR a CRA-RU."
        ],
        zdroj: [
          "Aplikácia VVVT,  rozsudkové údaje, portál Zdravotnej poisťovne a iné."
        ]
      },

      expertne_posudenie: {
        nazov: "Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia",
        zdroj: [],
        poznamka: [],
        priklad: [],
        charakteristika: [
          "Expertné posúdenie znamená komplexné hodnotenie, ktoré je založené na teoretických znalostiach a praktických skúsenostiach hodnotiteľa – poskytuje odpoveď na otázku Aká je z Vášho profesionálneho pohľadu na odsúdeného pravdepodobnosť jeho opakovaného zlyhania (trestnej činnosti) v najbližších dvoch rokoch?"
        ]
      }
    }
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    }
  },

  created() {
    this.getItem();
  },

  methods: {
    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    clear() {
      this.form.vek = "";
      this.form.pohlavie = "";
      this.form.vo_vtos = "";
      this.form.najvyssie_dosiahnute_vzdelanie = "";
      this.form.aktualne_odsudeny_za = "";
      this.form.porusenie_podmienky = "";
      this.form.clenstvo_v_zlocineckej = "";
      this.form.aktualna_dlzka_nepretrziteho_pobytu = "";
      this.form.dlzka_zamestnania_rok_pred = "";
      this.form.spolupraca_s_inymi_org = "";
      this.form.zabezpecenie_byvania_po = "";
      this.form.aktualna_financna_situacia = "";
      this.form.expertne_posudenie = "nehodnotené";
    },
    getItem() {
      apiService.getRizikoveFaktory(this.$route.params.id).then(response => {
        this.form = response;
      });
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.craItem = response;
      });
    },
    updateItem() {
      apiService.updateRizikoveFaktory(this.form, this.$route.params.id).then(
        () => {
          this.snackbar_saved = true;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    openItem() {
      apiService
        .updateRizikoveFaktory(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          response => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updateRizikoveFaktory(this.form, this.$route.params.id)
              .then(
                response => {
                  this.snackbar_saved = true;
                  this.form = response;
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    }
  }
};
</script>
